import { createFeatureSelector, createSelector } from '@ngrx/store';
import { helpResourcesFeatureKey, HelpResourcesState } from './help-resources.reducer';

export const getHelpResourcesStateFeatureState = createFeatureSelector<HelpResourcesState>(helpResourcesFeatureKey);

export const getHelpResourcesState = createSelector(getHelpResourcesStateFeatureState, (state: HelpResourcesState) => state);
